import { Defs, Image, LinearGradient, Rect, Stop, Svg } from '@react-pdf/renderer';
import bannerWave from '../assets/banner-wave.jpg';

// Full-bleed banner backdrop for the one-pager PDFs (BPP-231): the approved wave art
// (downscaled to 1400px / ~80KB so every generated PDF stays light), a left-to-right
// legibility scrim, and the gold bottom rail — per the design in
// Interim One-Pager-print v2. Render inside a relatively-positioned banner View,
// before the banner content.
export const PDF_BANNER_HEIGHT = 180;

// Letter page width in points.
const PAGE_WIDTH = 612;

export default function PdfBannerBackdrop({
  width = PAGE_WIDTH,
  height = PDF_BANNER_HEIGHT,
}: {
  width?: number;
  height?: number;
}) {
  const w = width;
  const h = height;
  return (
    <>
      <Image
        src={bannerWave}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: w,
          height: h,
          objectFit: 'cover',
        }}
      />
      <Svg
        width={w}
        height={h}
        viewBox={`0 0 ${w} ${h}`}
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <Defs>
          <LinearGradient id="bwBannerScrim" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0" stopColor="#091428" stopOpacity={0.9} />
            <Stop offset="0.42" stopColor="#091428" stopOpacity={0.55} />
            <Stop offset="1" stopColor="#091428" stopOpacity={0.15} />
          </LinearGradient>
          <LinearGradient id="bwBannerGold" x1="0" y1="0" x2="1" y2="0">
            <Stop offset="0" stopColor="#FBBF2B" />
            <Stop offset="1" stopColor="#EDAA42" />
          </LinearGradient>
        </Defs>

        {/* Legibility scrim: darker on the left where the text sits */}
        <Rect x={0} y={0} width={w} height={h} fill="url('#bwBannerScrim')" />

        {/* Gold bottom rail */}
        <Rect x={0} y={h - 3} width={w} height={3} fill="url('#bwBannerGold')" />
      </Svg>
    </>
  );
}
